const tradestatistic = {
  path: 'tradestatistic',
  component: resolve => require(['@/pages/admin/trading/tradestatistic'], resolve)
}

export default tradestatistic
